import { ImageFrame as e, MainImg as t } from "../styles.mjs";
import { useState as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/FullscreenGallery/components/GalleryMainImage.tsx
var a = ({ src: a, alt: o }) => {
	let [s, c] = n({
		current: a,
		outgoing: null
	});
	return s.current !== a && c({
		current: a,
		outgoing: s.current
	}), /* @__PURE__ */ i(e, { children: [s.outgoing && s.outgoing !== a && /* @__PURE__ */ r(t, {
		src: s.outgoing,
		alt: "",
		draggable: !1
	}, s.outgoing), /* @__PURE__ */ r(t, {
		$entering: !0,
		src: a,
		alt: o,
		draggable: !1,
		onAnimationEnd: () => c({
			current: a,
			outgoing: null
		})
	}, a)] });
};
//#endregion
export { a as GalleryMainImage };
